import { createContext, useContext } from 'react';

/* ─── Shared Theme Palettes ─────────────────────────────────────────────────
   Import DARK / LIGHT from here in any page that needs theming.
   The ThemeContext value is { isDark, T } where T is the active palette.
─────────────────────────────────────────────────────────────────────────── */

export const DARK = {
  bg:       '#030712',
  panel:    '#060d1f',
  card:     '#0c1222',
  border:   'rgba(56,189,248,0.10)',
  borderHd: 'rgba(99,179,237,0.07)',
  hdrBg:    'rgba(3,7,18,0.8)',
  cardGrad: 'linear-gradient(145deg,rgba(99,179,237,0.04),rgba(139,92,246,0.03))',
  inputBg:  'rgba(56,189,248,0.03)',
  inputBdr: 'rgba(56,189,248,0.15)',
  inputFocus:'#38bdf8',
  scrollC:  '#334155',
  sky:      '#38bdf8',
  violet:   '#8b5cf6',
  indigo:   '#6366f1',
  cyan:     '#22d3ee',
  emerald:  '#34d399',
  amber:    '#fbbf24',
  rose:     '#fb7185',
  slate:    '#64748b',
  text:     '#e2e8f0',
  dim:      '#64748b',
  muted:    '#334155',
  isDark:   true,
};

export const LIGHT = {
  bg:       '#f0f4f8',
  panel:    '#ffffff',
  card:     '#ffffff',
  border:   'rgba(99,102,241,0.13)',
  borderHd: 'rgba(99,102,241,0.10)',
  hdrBg:    'rgba(255,255,255,0.92)',
  cardGrad: 'linear-gradient(145deg,rgba(99,102,241,0.04),rgba(56,189,248,0.02))',
  inputBg:  'rgba(99,102,241,0.03)',
  inputBdr: 'rgba(99,102,241,0.18)',
  inputFocus:'#4f46e5',
  scrollC:  '#cbd5e1',
  sky:      '#0ea5e9',
  violet:   '#7c3aed',
  indigo:   '#4f46e5',
  cyan:     '#0891b2',
  emerald:  '#059669',
  amber:    '#d97706',
  rose:     '#e11d48',
  slate:    '#64748b',
  text:     '#0f172a',
  dim:      '#64748b',
  muted:    '#e2e8f0',
  isDark:   false,
};

export const ThemeContext = createContext({ isDark: true, T: DARK });
export const useTheme = () => useContext(ThemeContext);
